(function(){
  var HIDE='pv-esc-hidden';
  var SEL=[
    '.menu-lv-item:hover > .header__submenu',
    '.menu-lv-item.menu-lv-2.dropdown:hover .site-nav-list-dropdown > .header__submenu',
    '.menu-lv-item.has-megamenu:hover > .menu-dropdown'
  ].join(', ');
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape'&&e.key!=='Esc')return;
    if(!window.matchMedia('(min-width:1025px)').matches)return;
    var panels=document.querySelectorAll(SEL);
    if(!panels.length)return;
    panels.forEach(function(p){
      if(p.closest('#navigation-mobile'))return;
      var li=p.closest('.menu-lv-item')||p.closest('.dropdown');
      p.classList.add(HIDE);
      var ae=document.activeElement;
      if(ae&&p.contains(ae)){
        var trig=li&&(li.querySelector(':scope > a')||li.querySelector('a'));
        if(trig&&typeof trig.focus==='function')trig.focus();
      }
      if(li){li.addEventListener('mouseleave',function(){p.classList.remove(HIDE);},{once:true});}
    });
  });
})();
